module.exports = __webpack_public_path__ + "static/media/Beach11.f44cb648.jpg";